module.exports = __webpack_public_path__ + "img/guaxiang.80ce546d.png";